"use client";

import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ThreeDMarquee } from "./ui/3d-marquee";

export default function Marquee() {
  const images = [
    "https://img.freepik.com/free-photo/hand-holding-photo-camera_23-2150630970.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/high-angle-shot-lens-headphones-gimbal-phone_181624-43878.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/black-camera-lens-blue-surface_417767-380.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/black-camera-lens-brown-wooden-table_417767-6.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/premium-photo/flat-lay-with-camera-gear-white-background_950002-539137.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/digital-lens-isolated-white-background_53876-47075.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/premium-photo/examined-detail-electronic-shutter-digital-camera_158518-5905.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/cassettes-amidst-cameras-pink-background_23-2147852460.jpg?ga=GA1.1.111862559.1748167983&w=740",
    "https://img.freepik.com/premium-photo/old-film-camera-rarity-camera-camera-muse-hands-cocking-soviet-photographic-equipment-camera-macro-lens-inside-details_99274-127.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/high-angle-photo-camera-indoors-still-life_23-2150630617.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/photo-camera-still-life_23-2150630939.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/backpacker-relax-mountain-with-camera-adn-sunset_1150-7752.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/close-up-professional-camera-lens_23-2150720445.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/black-camera-lens-brown-wooden-table_417767-6.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/various-swappable-camera-objectives_140725-8083.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/view-electronic-product-balancing-podium_23-2150141323.jpg?ga=GA1.1.111862559.1748167983&w=740",
    "https://img.freepik.com/free-photo/film-amidst-vintage-cameras_23-2147852274.jpg?ga=GA1.1.111862559.1748167983&w=740",
    "https://img.freepik.com/free-photo/selective-focus-shot-person-holding-camera-lens_181624-46673.jpg?ga=GA1.1.111862559.1748167983&w=740",
    "https://img.freepik.com/free-photo/close-up-film-near-vintage-cameras_23-2147852529.jpg?ga=GA1.1.111862559.1748167983&w=740",
    "https://img.freepik.com/free-photo/set-various-vintage-cameras_23-2147852393.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/premium-photo/set-camera-photography-equipment-dark-wooden-table-flatlay-composition-professional-photographer_160321-1050.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/line-cameras-near-film_23-2147852334.jpg?ga=GA1.1.111862559.1748167983&w=740",
    "https://img.freepik.com/free-photo/close-up-film-near-vintage-cameras_23-2147852529.jpg?ga=GA1.1.111862559.1748167983&w=740",
    "https://img.freepik.com/free-photo/set-various-vintage-cameras_23-2147852393.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/premium-photo/set-camera-photography-equipment-dark-wooden-table-flatlay-composition-professional-photographer_160321-1050.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/line-cameras-near-film_23-2147852334.jpg?ga=GA1.1.111862559.1748167983&w=740",
    "https://img.freepik.com/free-photo/hand-holding-photo-camera_23-2150630970.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
    "https://img.freepik.com/free-photo/high-angle-shot-lens-headphones-gimbal-phone_181624-43878.jpg?ga=GA1.1.111862559.1748167983&semt=ais_hybrid&w=740",
  ];

  return (
    <div className="relative mx-auto my-10 flex h-[80vh] w-full max-w-7xl flex-col items-center justify-center overflow-hidden rounded-3xl">
      <div className="relative z-20 mx-auto max-w-4xl text-center">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl md:text-6xl font-bold tracking-tight text-white"
        >
          Revive, Relive, Reshoot{" "}
          <span className="text-3xl md:text-4xl relative z-20 inline-block rounded-xl bg-blue-500/40 px-4 py-1 text-white underline decoration-sky-500 decoration-[6px] underline-offset-[16px] backdrop-blur-sm">
            Bringing Focus Back To Life
          </span>
        </motion.h1>
       
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-10 flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Link
            to="/services"
            className="rounded-md bg-sky-600 px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-sky-700 focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 focus:ring-offset-black focus:outline-none"
          >
            Explore Services
          </Link>
          <Link
            to="/products"
            className="rounded-md border border-white/20 bg-white/10 px-6 py-2.5 text-sm font-medium text-white backdrop-blur-sm transition-colors hover:bg-white/20 focus:ring-2 focus:ring-white/20 focus:ring-offset-2 focus:ring-offset-black focus:outline-none"
          >
            Adjustment Tools
          </Link>
        </motion.div>
      </div>

      {/* overlay */}
      <div className="absolute inset-0 z-10 h-full w-full bg-black/80 dark:bg-black/40" />
      <ThreeDMarquee
        className="pointer-events-none absolute inset-0 h-full w-full"
        images={images}
      />
    </div>
  );
}
